import axios from "axios";
import { customerCode } from "./index";

export const jsonRegex = /^\s*\{[\s\S]*\}\s*$/;

/**
 * 当日课程关闭直播（备课直播滑块关）
 */
export interface QueryRuleParams {
    courseNo: string; //课程编号
    courseSeq: string; //课程序号
    customerCode?: string; //客户代码
}
export interface ExtraRule {
    config: string | string[]; //加分项，由,号隔开目前会有两个固定值 discuss（主题讨论）、other（其他）
    gtHundred: BooleanValue; //总分能否超过100
}
export type ExtraType = null | undefined | ExtraRule;
export interface QueryRuleResult {
    batchNo: string; //学期编号
    courseNo: string; //课程编号
    courseSeq: string; //课程序号
    delStatus: number; //逻辑删除 0：未删除 1：已删除
    customerCode: string; //客户代码
    createTime: string; // 创建时间
    createUser: number; //创建者
    dailyGrade: number; //平时成绩占比
    finalGrade: number; //期末成绩占比
    dailyTotalScore: string; //平时成绩总分数
    finalTotalScore: string; //期末成绩总分数
    visible: string; //是否可见（0否1是）
    isProcess: BooleanValue; //是否是过程化考核（0否1是）
    updateUser: number; //更新者
    updateTime: string; //更新时间
    filePath: string; //下载路径
    fileName: string;
    fileType: string;
    description: string; //规则说明
    dailyGradeRuleModel: GradeRuleModelType[]; //平时成绩考核模块列表
    finalGradeRuleModel: GradeRuleModelType[]; //期末成绩考核模块列表
    extraRule: ExtraType; //额外加分
}
export interface GradeRuleModelType {
    id: number; //考核模块id
    ruleId: number; // 所属考核id
    ruleName: string; //考核模块名称
    weight: number; //权重
    description: string; //成绩规则说明
    formulaModeJson: string; //成绩细则json(由前端自定义，告诉后端就行)
    type: BooleanValue; //类型：0平时成绩 1期末成绩
    fixed: BooleanValue; //是否固定: 0否1是
    delStatus: number; //删除标识  0否1是
    calculateClass?: string;
    remark: string; //备注
    flag?: string;
}
export function queryRule(params: QueryRuleParams) {
    let param = {
        ...params,
        customerCode: customerCode
    };
    return axios
        .post<SuccessData<QueryRuleResult>>("/student/rule/queryRule", param, {
            headers: {
                "Content-Type": "application/json;charset=UTF-8"
            }
        })
        .then(res => res.data.data)
        .then(data => {
            const dailyGradeRuleModel = data.dailyGradeRuleModel.map(item => ({
                ...item,
                flag: item.calculateClass?.split(".").pop(),
                remark:
                    item.remark && jsonRegex.test(item.remark)
                        ? ""
                        : item.remark
            }));

            const finalGradeRuleModel = data.finalGradeRuleModel.map(item => ({
                ...item,
                flag: item.calculateClass?.split(".").pop(),
                remark:
                    item.remark && jsonRegex.test(item.remark)
                        ? ""
                        : item.remark
            }));
            return { ...data, dailyGradeRuleModel, finalGradeRuleModel };
        });
}

export enum NavTab {
    Paper, //考核方案和成绩单
    Rules //成绩规则
}

/**
 * 筛选出权重不为0的数据
 * @param data
 */
export const filterData = (data: GradeRuleModelType[]) => {
    if (!data.length) return [];
    return data.filter(item => item.weight !== 0);
};

export const SelectMap: Record<
    string,
    {
        title: Record<string, string>;
    }
> = {
    //签到
    SignInCalculator: {
        title: {
            按出勤次数折算成对应得分: "出勤次数",
            按出勤率折算成对应得分: "出勤率"
        }
    },
    //投票
    VoteRateCalculator: {
        title: {
            按投票参与率折算对应得分: "投票参与率(%)",
            按投票参与次数折算对应得分: "投票参与次数"
        }
    },
    //练习
    ExerciseScoreCalculator: {
        title: {
            按所有练习的平均分计分: "练习平均分",
            按练习参与次数折算成对应得分: "练习参与次数"
        }
    },
    //作业
    HomeworkScoreCalculator: {
        title: {
            按所有作业的平均分计分: "作业平均分",
            按作业参与次数折算成对应得分: "作业参与次数"
        }
    },
    //小组活动
    GroupActivityScoreCalculator: {
        title: {
            按所有小组活动平均分计分: "小组活动平均分",
            按小组活动参与次数折算成对应得分: "小组活动参与次数"
        }
    },
    //小组活动
    DailyExamCalculator: {
        title: {
            按所有考试平均分计分: "考试平均分",
            按考试参与次数折算成对应得分: "考试参与次数"
        }
    }
};

export interface OtherRulesItem {
    rangeVal1: number; //参数1
    sign1: signType; //符号1
    rangeVal2: number; //参数2
    sign2: signType; //符号2
    grade: number; //得分
}

export interface queryGradeRuleItem {
    id: string;
    name: string;
    createTime: string;
    weight: number;
}

export interface AdvancedConfig {
    done: number; //正常出勤
    late: number; //迟到，早退
    leave: number; //请假
    otherRules?: OtherRulesItem[];
}

export interface AllConfig extends AdvancedConfig {
    detailWeight?: queryGradeRuleItem[];
}

export enum signType {
    lt = "0", //小于
    lessEqual = "1", //小于等于
    equal = "2", //等于
    moreEqual = "3", //大于
    gt = "4" //大于等于
}

export const SignMap: Record<string, string> = {
    [signType.lt]: "<",
    [signType.lessEqual]: "≤",
    [signType.equal]: "=",
    [signType.moreEqual]: "≥",
    [signType.gt]: ">"
};

export interface gradeArrayItem {
    id: string; // 数据id
    score: string; // 分数
    grade: string; // 占比
    name: string; //名称
    activityType: ActivityType;
    child: gradeChildItem[]; // 子集成绩数组
}

export interface gradeChildItem extends Omit<gradeArrayItem, "child"> {
    formulaModeJson: string;
    type: string;
    child: activityItem[];
}

export enum ActivityType {
    Courseware = "1", //课件√
    singIn = "2", //签到√
    Vote = "3", //投票√
    Homework = "4", //作业
    Exercise = "5", //练习
    GroupActivity = "6", //小组活动
    Exam = "7", //考试
    custom = "8" //自定义
}

export interface activityItem {
    stuStatus: string; //活动类型是 课件/签到/投票 时, 值为学生完成状态 0/1 ;  活动类型是 作业/练习/小组活动/考试/自定义 时, 值为学生作答分数
    name: string;
    weekTimeId: number; //活动所属weekTimeId
    id: string;
    activityType: ActivityType; //活动类型, 课件:1, 签到:2, 投票:3, 作业:4, 练习:5, 小组活动:6, 考试:7, 自定义:8
    child: any[];
    type?: string;
    week?: string;
    weektime?: string; //作业用
    paperId?: string; //作业用
    section?: string; //作业用
    continunity?: string; //作业用
    groupIds?: string;
    viewUrl?: string;
}

export interface extListProps {
    score: string;
    extraName: string;
}
export interface ScoreList {
    totalGrade: string; //总成绩
    finalGrade: string; // 最终成绩
    bonusPoints: string; // 成绩加分
    stuRank: string; //综合排名
    totalNum: string; //排名总数
    gradeArray: gradeArrayItem[]; // 成绩数组
    remark: string; //修改原因
    extraGrade: extListProps[];
}

export function getScoreList(courseNo: string, courseSeq: string) {
    let batchNo = window.localStorage.getItem("batch");

    return axios
        .get<SuccessData<ScoreList>>("/student/rule/getScoreList", {
            params: { courseNo, courseSeq, batchNo },
            headers: {
                "Content-Type": "application/json;charset=UTF-8"
            }
        })
        .then(res => res.data.data);
}

/**
 * 路由
 * @param courseNo
 * @param courseSeq
 * @param weekTimeId
 * @param data
 */

export function handleDetailPath(
    courseNo: string,
    courseSeq: string,
    weekTimeId: string,
    data: activityItem
) {
    const basename = `/course/detail/${courseNo}/${courseSeq}/${
        data.weekTimeId ? data.weekTimeId : weekTimeId
    }`;
    let path;
    const base64 = window.btoa(
        `${courseNo}-${courseSeq}-${data.weektime}-${data.week}-${data.section}-${data.continunity}-2-${data.id}-${data.weekTimeId}`
    );

    switch (data.activityType) {
        case ActivityType.Courseware:
            path = `${basename}`;
            break;
        case ActivityType.singIn:
            path = `${basename}/signin/${data.id}/${data.type}`;
            break;
        case ActivityType.Vote:
            path = `${basename}/vote/${data.id}`;
            break;
        case ActivityType.Exercise:
            path = `${basename}/exercise/detail/${data.id}`;
            break;
        case ActivityType.Homework:
            path = `/homework/${base64}`;
            break;
        case ActivityType.GroupActivity:
            path = `${basename}/teamDetail/${data.id}`;
            break;
        default:
            path = "";
            break;
    }

    return path;
}
